import React, { useEffect, useState } from 'react';
import './styles.sass';
import Image from "../../utils/Image";

const IndexPage = () => {

  const ranges = [
    { from: '2023-04-26T00:00:00+02:00', to: '2023-04-26T08:00:00+02:00' },
    { from: '2023-04-27T00:00:00+02:00', to: '2023-04-27T06:00:00+02:00' },
    { from: '2023-04-28T00:00:00+02:00', to: '2023-04-28T04:00:00+02:00' },
  ]
  const isBetweenRanges = () => {
    const now = new Date()
    for (let i = 0; i < ranges.length; i++) {
      const from = new Date(ranges[i].from)
      const to = new Date(ranges[i].to)
      if (now >= from && now <= to) {
        return true
      }
    }
    return false
  }

  if (isBetweenRanges()) {
    return (
      <div className="mangopay-banner">
        <div>Pour des raisons de maintenance, <u>le paiement est actuellement indisponible</u> jusqu'à 8h00 (CET)</div>
        <a href="mailto:contact@charles.co" className="d-flex ml-3 font-weight-normal text-white">
          <Image filename="new-images/envelope.svg" className="mr-2" alt="icon-envelope" />
          charles@charles.co
        </a>
      </div>
    )
  } else {
    return (
      <div id="contact-top-banner" className="contact-top-banner">
        <div className="d-none d-md-flex">
          Pour toute question vous pouvez joindre notre équipe :
        </div>
        <a href="tel:+33186651733">
          <Image filename="new-images/mobile.svg" alt="icone-de-telephone" title="icone-de-telephone" />
          <div>
            01 86 65 17 33
          </div>
        </a>
        <a href="mailto:contact@charles.co">
          <Image filename="new-images/envelope.svg" alt="icone-enveloppe" title="icone enveloppe"/>
          <div>
            contact@charles.co
          </div>
        </a>
      </div>

    );
  }
};

export default IndexPage;
